<template lang="pug">
b-modal#groupCall(
  ref="groupCall"
  :title="$t('ui.call')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      template(v-if="customerInfo == null")
        .row.w-100
          .form-group.col-12
            .alert.alert-warning.p-1.mb-1 {{ $t("message.tooltips_cpi_operator_phone") }}
          .form-group.col-12
            span.badge.badge-info {{ $t('ui.selected') }}:&ensp;{{ selectedPhone.length }}
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="8%")
                  span(:title="$t('ui.phone')") {{ $t('ui.phone') }}
                th.text-center(width="5%")
                  span(:title="$t('ui.action')") {{ $t('ui.action') }}
            tbody.clusterize-content
              tr(v-if="phoneList.length == 0")
                td(colspan="3").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in phoneList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.phone") {{ item.phone }}
                td.text-center
                  b-form-checkbox.checkboxModal(v-model="selectedPhone" :value='item.phone' :disabled="loading")
          ValidateResult(:value="$v.selectedPhone" :name="$t('ui.phone')", fvalue="5")
      template(v-else)
        .form-group
          span.badge.badge-info {{ customerInfo.id }}
        b-form-group(:label="$t('ui.phone')").mb-0
          b-form-select(
            size="sm"
            ref="selectedPhoneValue"
            :class="{ 'is-invalid': $v.selectedPhoneValue.$dirty == true && $v.selectedPhoneValue.$error == true, 'is-valid': $v.selectedPhoneValue.$dirty == true && $v.selectedPhoneValue.$error == false }"
            v-model.trim.lazy="$v.selectedPhoneValue.$model"
            :disabled="loading"
            )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(v-for="option in phoneList" :value="option.phone") {{ option.phone }}
          ValidateResult(:value="$v.selectedPhoneValue" :name="$t('ui.phone')")


    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-phone-volume" :text="$t('ui.call')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import { required, requiredIf } from "vuelidate/lib/validators";
const pleaseSelectUpToNoPhone = (value, vm) => {
  return value.length > 0 && value.length < 6;
};

export default {
  components: {
    SubmitButton,
    ValidateResult
  },
  props: {
    customerInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      phoneList: [],
      selectedPhone: []
    };
  },
  computed: {
    selectedPhoneValue: {
      get() {
        return this.selectedPhone[0] || ''
      },
      set(val) {
        this.selectedPhone = val ? [val] : []
      }
    }
  },
  validations() {
    return {
      selectedPhone: {
        pleaseSelectUpToNoPhone,
      },
      selectedPhoneValue: {
        required: requiredIf(function () {
          return this.customerInfo != null
        })
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submit();
    },
    submit: function() {
      let url = "";

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
      };
      if(this.customerInfo == null) {
        // Group
        url = config.cpiGroupCallCreateUrl();

        json.operator_phone_list = this.selectedPhone.toString()
        json.group_size = this.selectedPhone.length
      } else {
        // Single
        url = config.cpiSingleCallCreateUrl();

        json.operator_phone = this.selectedPhone.toString()
        json.customer_id = this.customerInfo.id
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.groupCall.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "call", this.feedback.status);
                this.$refs.groupCall.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getCpiOperatorPhoneLookup() {
      let url = config.cpiOperatorPhoneLookupUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        account_id: this.$store.getters.accountId
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.phoneList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.phoneList = [];
      this.selectedPhone = []
      this.$v.$reset();
    },
    shown: function() {
      this.getCpiOperatorPhoneLookup();
    }
  }
};
</script>
